import useLocalDataStore from "@/hooks/common/useLocalDataStore";
import * as style from "@COMPONENTS/style/productlist/departurepopupM";
import {GoodsDetail} from "@QUERIES/prdt/goods/useGoodsDetail";
import React from "react";

interface Props {
	state: {
		key: string;
		text: string;
		value: string;
	};
	index: number;
	productDetail: GoodsDetail;
}

const EventListState = ({state, index, productDetail}: Props) => {
	const {getLocalData, addLocalData, setLocalData} = useLocalDataStore();
	const filters = getLocalData("departureFilters") ?? [];

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const key = state.key;
		const {checked, value} = e.target;
		const text = e.target.parentNode.lastChild.textContent;

		if (checked) {
			const hasFilter = filters.some(item => item.value === value && item.key === key);

			if (hasFilter) return;
			addLocalData({key: "departureFilters", value: {key, value, text}});
		} else {
			setLocalData({
				key: "departureFilters",
				value: filters.filter(item => !(item.value === value && item.key === key)),
			});
		}
	};

	return (
		<style.FilterCheck>
			<input
				type="checkbox"
				id={`state${productDetail.goodsCd}${index}`}
				name={`state${productDetail.goodsCd}${index}`}
				value={state.value}
				checked={filters.some(v => v.key === state.key || false)}
				onChange={handleChange}
			/>
			<label htmlFor={`state${productDetail.goodsCd}${index}`}>{state.text}</label>
		</style.FilterCheck>
	);
};

export default EventListState;
